import React from 'react';

import Section from '@dashboard/components/sections/Section';
import { usePlatformQuery } from '@dashboard/generated/wp/administrator';
import { Divider } from '@mui/material';

import EditPlatformDialog from '../EditPlatformDialog';

import PlatformProperties from './PlatformProperties';
import SesConfiguration from './SesConfiguration';

type Props = {
  id: string;
};
export default function Header({ id }: Props) {
  const { data } = usePlatformQuery({ variables: { id } });
  return (
    <Section action={<EditPlatformDialog platformId={id} />} title={data?.Platform.name ?? id} variant="primary">
      <PlatformProperties platformId={id} />
      <Divider />
      <h3>SES Configuration</h3>
      <SesConfiguration platformId={id} />
    </Section>
  );
}
